import { EOfficeType, Filters } from 'shared/types/filters';

export const includesOfficeType = (filters: Filters): boolean => {
  return filters.officeType.includes(EOfficeType.Office);
};
